{
  "version": 1,
  "asset_id": "f463f5eb-48a2-4426-bf0e-49157b425621",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/f463f5eb-48a2-4426-bf0e-49157b425621/clip-img_2005-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/f463f5eb-48a2-4426-bf0e-49157b425621/clip-img_2005-poster-sm.webp",
  "original_filename": "clip-img_2005-poster-sm.webp",
  "size": 12482,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:17Z"
}
